import { ChargePreview } from "../../models";

type Result = {
  creditApplied: number;
  newCredit: number;
  remainingCredit: number;
  newCharges: number;
  totalDueToday: number;
};
export default function analyzeChargePreview(chargePreview: ChargePreview): Result {
  const newCredit = Math.abs(Math.min(chargePreview.newCharges, 0)),
    newCharges = Math.max(chargePreview.newCharges, 0),
    existingCredit = Math.abs(Math.min(chargePreview.existingCredit, 0)),
    creditApplied =
      newCharges > 0 && existingCredit > 0 ? Math.min(chargePreview.newCharges, existingCredit) : 0,
    remainingCredit = Math.max(existingCredit - creditApplied + newCredit, 0),
    totalDueToday = Math.max(chargePreview.total, 0);

  return {
    newCredit,
    newCharges,
    creditApplied,
    remainingCredit,
    totalDueToday: totalDueToday,
  };
}
